import spinner from '../utils/rbmc.spinner';
import gigyaLiteRegistration from './rbmc.lite-registration';

const contestParticipation = {
    $questionsForm:             undefined,
    $gigyaContestForm:          undefined,
    $contestFormButtonOriginal: undefined,
    $contestFormButtonFake:     undefined,
    $contestSubscriptionId:     undefined,
    $error:                     undefined,
    $subscriptionTagData:       [],
    $questionsBooleanArray:     [],
    $questionsAnswersArray:     [],
    questionValidityPromises:   [],
    $formCountValidity:         0,
    $totalQuestionsFormCount:   0,
    init:                       function () {
        this.$questionsForm = $('.contest-page__questions');
        this.$contestSubscriptionId = this.$questionsForm.data('subscription-id');
        this.$questionsFormChoice = this.$questionsForm.find('form.contest-page__question-choice');
        this.$questionsFormInput = this.$questionsForm.find('form.contest-page__question-input');
        this.$gigyaContestForm = $('[id^=cdc-gigya-contest] form');
        this.$error = this.$questionsForm.find('.contest-page__error');
        this.$totalQuestionsFormCount = this.$questionsFormChoice.length + this.$questionsFormInput.length;

        /**
         * Create fake button and attach event to it
         * This event will serve to check questions first, then continue with cdc form
         */
        this.$contestFormButtonOriginal = this.$gigyaContestForm
                                              .find('input[type=submit]');
        this.$contestFormButtonFake = this.$gigyaContestForm
                                          .find('input[type=submit]')
                                          .clone()
                                          .attr('type', 'button')
                                          .addClass('check-questions');

        // Append fake button as sibling to original
        this.$gigyaContestForm
            .find('.gigya-composite-control-submit')
            .append(this.$contestFormButtonFake);

        // CDC original submit button
        this.$contestFormButtonOriginal.addClass('d-none');

        this.$contestFormButtonFake.on('click', function () {
            contestParticipation.getQuestions();
        });

        // Make sure one checkbox is checked at one time per form
        this.$questionsFormChoice.find('input').on('change', function (event) {
            const $this = $(event.target);
            event.preventDefault();
            $this.closest('form').find('input').prop('checked', false);
            $this.prop('checked', true);
            contestParticipation.resetButtonAndErrors();
        });

        this.$questionsFormInput.find('input').on('change keyup', () => contestParticipation.resetButtonAndErrors());
    },

    getQuestions: function () {
        // Reset if checking again
        contestParticipation.$subscriptionTagData = [];
        contestParticipation.$questionsBooleanArray = [];
        contestParticipation.$questionsAnswersArray = [];
        contestParticipation.questionValidityPromises = [];
        contestParticipation.$formCountValidity = 0;

        // Get forms with optional answers
        if (this.$questionsFormChoice.length) {
            $.each(this.$questionsFormChoice, function (index, form) {
                const $form = $(form);
                if ($form.find('input:checked').length) {
                    const promise = contestParticipation.checkQuestion(
                            $form.data('uid'),
                            $form.find('input:checked').val()
                    );
                    //Gather all question promises to an array
                    contestParticipation.questionValidityPromises.push(promise);
                    contestParticipation.$formCountValidity++;
                }
            });
        }

        // Get forms with single answer
        if (this.$questionsFormInput.length) {
            $.each(this.$questionsFormInput, function (index, form) {
                const answer = $(form).find('input').val();
                if (answer !== '') {
                    contestParticipation.$subscriptionTagData.push(answer);
                    contestParticipation.$formCountValidity++;
                }
            });
        }

        if (contestParticipation.$totalQuestionsFormCount === contestParticipation.$formCountValidity) {
            spinner.spinnerVisibility(true);
            this.$error.addClass('d-none');

            // Resolve all promises and gather results to finally resolve correct answers
            if (this.$questionsFormChoice.length) {
                Promise.all(contestParticipation.questionValidityPromises)
                       .then(promisesResult => promisesResult.map(
                               status => {
                               contestParticipation.$questionsBooleanArray.push(status.success);
                               contestParticipation.$questionsAnswersArray.push(status.answer);
                               }))
                       .then(() => {
                           // Push final calculation of questions form answer validity
                           contestParticipation.$subscriptionTagData.push(contestParticipation.resolveQuestionsFormValidity());
                           contestParticipation.$subscriptionTagData = contestParticipation.$subscriptionTagData.concat(contestParticipation.$questionsAnswersArray);

                           // Show original button back and hide fake, then trigger cdc form submit
                           contestParticipation.$contestFormButtonFake.addClass('d-none');
                           contestParticipation.$contestFormButtonOriginal
                                               .removeClass('d-none')
                                               .trigger('click');

                           spinner.spinnerVisibility();
                       });
            }
        } else {
            this.$questionsForm[0].scrollIntoView({behavior: 'smooth'});
            this.$error.removeClass('d-none');
        }
    },

    /**
     * * When submit event of contest screen is called, this one will be triggered from lite-registration.js
     * It takes event and will inject data into subscription tag property
     * @param event
     * @returns {}
     */
    injectContestSubscriptionTagData: (event) => {
        const eventDetail = event.detail;
        if (eventDetail.screen.includes(gigyaLiteRegistration.CDC_CONTEST_PARTICIPATION_PREFIX)
                && contestParticipation.$subscriptionTagData.length) {
            const formData = eventDetail.formModel;
            const subscriptions = formData.subscriptions;
            // If there is subscription that matches subscription id provided on component, attach tags
            if (subscriptions.hasOwnProperty(contestParticipation.$contestSubscriptionId)) {
                subscriptions[contestParticipation.$contestSubscriptionId].email.tags = contestParticipation.$subscriptionTagData;
            }
            return formData;
        }
    },

    /**
     * Detect falsy value in question validity boolean array. If false found then return false
     * @returns {boolean}
     */
    resolveQuestionsFormValidity: () => !contestParticipation.$questionsBooleanArray.includes(false),

    /**
     * Currently we create separate request to check question validity.
     * This may change at some point -> send object with answers in one single request
     */
    checkQuestion: function (componentId, answer) {
        return $.get(`${ACC.config.encodedContextPath}/contest/question/`, {
            componentId: componentId,
            answer:      answer || ''
        });
    },

    resetButtonAndErrors() {
        this.$contestFormButtonFake.removeClass('d-none')
        this.$contestFormButtonOriginal.addClass('d-none');
        this.$error.addClass('d-none');
    }
}

export default contestParticipation;
